import {
  Required,
  DataValidator,
  transformKeys,
  IsString,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";
import { isNumber } from "util";

export interface FeatureDetailAllResponse {
  data: Array<Data>;
};

export interface Data {
  id: number;
  owner_type: number;
  owner_id: number;
  pid: number;
  feature_type: number;
  feature_code: string;
  feature_time_unit: number;
  feature_time_count: number;
  order_item_id: number;
  order_id: number;
  is_number_unlimited: number;
  total_val: number;
  used_val: number;
  extra?: string;
  main_pid_max_version?: string;
  expire_time: number;
  is_expired: number;
  is_renew: number;
  create_time: number;
  update_time: number;
  order_item: OrderItem;
};

export interface OrderItem {
  id: number;
  item_id: number;
  order_id: number;
  create_time: number;
  item_info: ItemInfo;
};

export interface ItemInfo {
  id: number;
  item_code: string;
  item_name: string;
  subscription_template_id: number;
  create_time: number;
  update_time: number;
  prices?: string;
};

// ==============
export class ItemInfoData {
  @Required("id cannot be empty")
  @IsNumber("id must be a number")
  id: number;

  @Required("item code cannot be empty")
  @IsString("item code must be a string")
  itemCode: string;

  @Required("item name cannot be empty")
  @IsString("item name must be a string")
  itemName: string;

  @Required("create time cannot be empty")
  @IsNumber("create time must be a number")
  createTime: number;

  @IsString("prices must be a string")
  @IsNumber("prices must be a number")
  prices?: string;
}

export class OrderItemData {
  @Required("id cannot be empty")
  @IsNumber("id must be a number")
  id: number;

  @Required("item id cannot be empty")
  @IsNumber("item id must be a number")
  itemId: number;

  @Required("order id cannot be empty")
  @IsNumber("order id must be a number")
  orderId: number;

  @IsNumber("create time must be a number")
  createTime: number;

  @Required("create time cannot be empty")
  itemInfo?: ItemInfoData;
}

export class FeatureDetailAllData {
  @Required("id cannot be empty")
  @IsNumber("id must be a number")
  id: number;

  @Required("feature code cannot be empty")
  @IsString("feature code must be a string")
  featureCode: string;

  @Required("total val cannot be empty")
  @IsNumber("total val must be a number")
  totalVal: number;

  @Required("used val cannot be empty")
  @IsNumber("used val must be a number")
  usedVal: number;

  @IsNumber("create time must be a number")
  createTime: number;

  @Required("order item cannot be empty")
  orderItem?: OrderItemData;
}

const transformAndValidateData = (
  response: FeatureDetailAllResponse
): FeatureDetailAllData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, FeatureDetailAllData);
  } catch (error) {
    console.error("Feature all data validation failed:", error.message);
    throw error;
  }
};

/** 获取用户权益明细 */
export const featureDetailAll = async (): Promise<FeatureDetailAllData[]> => {
  const res = await api.post<FeatureDetailAllResponse[]>('/feature_detail/all');
  const data = res.data.map(transformAndValidateData);
  return data;
}